function toggleSearchButton(display = false) {
    const el = document.querySelector('.m-masthead__social-search');

    if (el) {
        if (display) {
            el.style.display = 'list-item';
        } else {
            el.style.display = 'none';
        }
    }
}

window.toggleSearchButton = toggleSearchButton;
